// extracted by mini-css-extract-plugin
module.exports = {"section":"DifferenceCustomDevelopment_section__tocSR","subject":"DifferenceCustomDevelopment_subject__dMbNX","title":"DifferenceCustomDevelopment_title__Jx6tm"};